import { render, staticRenderFns } from "./radioplayer.vue?vue&type=template&id=aeaf8b50&scoped=true&"
import script from "./radioplayer.vue?vue&type=script&lang=js&"
export * from "./radioplayer.vue?vue&type=script&lang=js&"
import style0 from "./radioplayer.vue?vue&type=style&index=0&id=aeaf8b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaf8b50",
  null
  
)

export default component.exports